/**
 * Theme utility classes for consistent design system usage
 * Use these instead of arbitrary values throughout the app
 * 
 * All colors and utilities are defined in styles/globals.css @theme inline block
 */

export const theme = {
  colors: {
    primaryOrange: 'bg-primary-orange dark:bg-primary-orange-dark',
    backgroundCream: 'bg-background-cream dark:bg-gray-900',
    cardCream: 'bg-card-cream dark:bg-gray-800',
    lightGray: 'bg-light-gray dark:bg-gray-600',
    warmYellow: 'bg-warm-yellow dark:bg-primary-orange-dark/20',
    warmYellowBg: 'bg-warm-yellow-bg dark:bg-gray-800',
    warmYellowBorder: 'border-warm-yellow-border dark:border-gray-600',
    slate950: 'bg-slate-950 dark:bg-gray-700',
    errorBg: 'bg-error-bg dark:bg-error-bg-dark',
  },
  
  text: {
    primaryOrange: 'text-primary-orange-dark dark:text-primary-orange',
    error: 'text-error-text dark:text-error-text-dark',
  },
  
  ring: {
    primaryOrange: 'ring-primary-orange dark:ring-primary-orange-dark',
  },
  
  shadows: {
    neubrutalism: 'shadow-neubrutalism dark:shadow-neubrutalism-dark',
    neubrutalismLg: 'shadow-neubrutalism-lg dark:shadow-neubrutalism-lg-dark',
    neubrutalismSm: 'shadow-neubrutalism-sm dark:shadow-neubrutalism-sm-dark',
    neubrutalism2: 'shadow-neubrutalism-2 dark:shadow-neubrutalism-2-dark',
    neubrutalism3: 'shadow-neubrutalism-3 dark:shadow-neubrutalism-3-dark',
  },
  
  borders: {
    neubrutalism: 'border-3 border-gray-900 dark:border-gray-300',
    neubrutalismThick: 'border-4 border-gray-900 dark:border-gray-300',
    slate950: 'border-3 border-slate-950 dark:border-gray-700',
    error: 'border-3 border-error-border dark:border-error-border-dark',
  },
  
  buttons: {
    primary: 'bg-primary-orange dark:bg-primary-orange-dark text-gray-900 dark:text-white border-3 border-gray-900 dark:border-gray-300 shadow-neubrutalism dark:shadow-neubrutalism-dark hover:-translate-y-0.5 transition-transform',
    secondary: 'bg-white dark:bg-gray-800 border-3 border-gray-900 dark:border-gray-700 shadow-neubrutalism dark:shadow-neubrutalism-dark hover:-translate-y-0.5 transition-transform',
    destructive: 'bg-red-600 dark:bg-red-500 text-white border-3 border-gray-900 dark:border-gray-300 shadow-neubrutalism dark:shadow-neubrutalism-dark hover:-translate-y-0.5 transition-transform',
  },
  
  cards: {
    base: 'bg-white/80 dark:bg-gray-800/90 backdrop-blur border-3 border-gray-900 dark:border-gray-300 rounded-2xl shadow-neubrutalism-lg dark:shadow-neubrutalism-lg-dark',
    episode: 'bg-white dark:bg-gray-800 border-3 border-gray-900 dark:border-gray-700 rounded-xl shadow-neubrutalism dark:shadow-neubrutalism-dark',
  },
  
  tags: {
    format: 'bg-primary-orange dark:bg-amber-600 border-3 border-gray-900 dark:border-gray-700 text-gray-900 dark:text-white',
    theme: 'bg-light-gray dark:bg-gray-600 border-3 border-gray-900 dark:border-gray-700 text-gray-900 dark:text-white',
    topic: 'bg-white dark:bg-gray-700 border-3 border-gray-900 dark:border-gray-700 text-gray-900 dark:text-white',
  },
  
  animations: {
    chatBounce: 'animate-chat-bounce',
    buttonBlinking: 'animate-button-blinking',
  }
} as const;
